module.exports = __webpack_public_path__ + "static/img/product04.eece2f90.jpg";